import { atom } from 'jotai';
import { createMutationAtom } from 'atoms/create-resource-atom';

import { TitleCalculationResponse } from 'types/api-responses';

const titleCalculationPusherErrorMessageAtom = atom('');

export type TitleCalculationActivity = {
  isCalculating: boolean;
  startedAt: string | null;
  completedAt: string | null;
  progress: number | null;
};

const titleCalculationActivityAtom = atom<TitleCalculationActivity>({
  isCalculating: false,
  startedAt: null,
  completedAt: null,
  progress: null,
});

const newTitleCalculationAtom = createMutationAtom<
  TitleCalculationResponse,
  'workspaceCalculation'
>();

const cancelTitleCalculationAtom = createMutationAtom<
  any,
  'cancelCalculation'
>();

export {
  newTitleCalculationAtom,
  cancelTitleCalculationAtom,
  titleCalculationPusherErrorMessageAtom,
  titleCalculationActivityAtom,
};
